import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getDealers = async ({ commit }) => {
  commit('setDealerIsLoading', true);
  let url = `/dealers/selectable`;

  await connection.get(url)
    .then(res => {
      const dealers = res.data.data;
      commit('setDealersSelectable', dealers);
      commit('setDealerIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setDealerIsLoading', false);
    });
}

export const loadDealers = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setDealerIsLoading', true);
    let url = `/dealers`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const dealers = res.data.data;
        commit('setDealers', dealers);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setDealersPaginated', res.data);
        commit('setDealerIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setDealerIsLoading', false);
      });
}

export const dealerById = async ({ commit }, id) => {
  commit('setDealerIsLoading', true);
  await connection.get(`/dealers/${id}`)
    .then(res => {
      commit('setDealerDetail', res.data.data);
      commit('setDealerIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setDealerIsLoading', false);
    });
}

export const storeDealer = async ({ commit }, dealer) => {
  commit('setDealerIsCreating', true);
  await connection.post(`/dealers/create`, dealer)
    .then(res => {
      commit('saveNewDealers', res.data.data);
      commit('setDealerIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setDealerIsCreating', false);
    });
}

export const updateDealer = async ({ commit }, dealer ) => {
  commit('setDealerIsUpdating', true);
  await connection.put(`/dealers/${dealer.id}/update`, dealer)
    .then(res => {
      commit('saveUpdatedDealer', res.data.data);
      commit('setDealerIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setDealerIsUpdating', false);
    });
}

export const deleteDealer = async ({ commit }, dealer) => {
  commit('setDealerIsDeleting', true);
  await connection.delete(`/dealers/${dealer.id}/delete`)
    .then(res => {
      commit('setDeleteDealer', res.data.data);
      commit('setDealerIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setDealerIsDeleting', false);
    });
}
